<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
	import { inject, ref, watchEffect } from "vue";
	const icons = inject<Record<string, string>>("icons") ?? {};

	const props = defineProps<{
		name: string;
	}>();
	const src = ref(icons[props.name] ?? "");
	watchEffect(() => (src.value = icons[props.name] ?? ""));
</script>
<template>
	<i
		class="icon"
		v-html="src"
	/>
</template>

<style>
	.icon > svg {
		display: block;
		width: 100%;
		height: 100%;
	}
</style>
